import { render, staticRenderFns } from "./program_details.vue?vue&type=template&id=b8cad452&scoped=true&"
import script from "./program_details.vue?vue&type=script&lang=js&"
export * from "./program_details.vue?vue&type=script&lang=js&"
import style0 from "./program_details.vue?vue&type=style&index=0&id=b8cad452&prod&lang=css&"
import style1 from "./program_details.vue?vue&type=style&index=1&id=b8cad452&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cad452",
  null
  
)

export default component.exports